import React from 'react';
import { Box } from '@mui/material';
import { parseTimeToHour } from './hooks/dateUtils';

const overlayStyle = {
  position: 'absolute',
  left: 0,
  right: 0,
  zIndex: 1,
  pointerEvents: 'none',
  background: 'repeating-linear-gradient(135deg, transparent, transparent 5px, rgba(0,0,0,0.015) 5px, rgba(0,0,0,0.015) 10px)',
  bgcolor: 'rgba(0,0,0,0.015)',
};

/**
 * Hatches the part of one day column outside that day's work hours. The grid rows are the union
 * of every open day's hours, so on a short Friday (8-14 in a Mon-Thu 8-17 week) the rows run to
 * 17:00 and 14-17 is hatched. ``hours`` is {start, end} ("HH:MM") for the day, null for a day off
 * (the whole column is hatched), or undefined when unknown (nothing is drawn).
 */
const NonWorkingHoursOverlay = ({ hours, startHour, endHour, hourHeight }) => {
  if (hours === undefined) return null;
  if (hours === null) {
    return <Box data-testid="non-working-overlay" data-kind="day" sx={{ ...overlayStyle, top: 0, bottom: 0 }} />;
  }
  const workStart = parseTimeToHour(hours.start, startHour);
  const workEnd = parseTimeToHour(hours.end, endHour);
  return (
    <>
      {workStart > startHour && (
        <Box
          data-testid="non-working-overlay"
          data-kind="before"
          sx={{ ...overlayStyle, top: 0, height: (workStart - startHour) * hourHeight }}
        />
      )}
      {workEnd < endHour && (
        <Box
          data-testid="non-working-overlay"
          data-kind="after"
          sx={{ ...overlayStyle, top: (workEnd - startHour) * hourHeight, bottom: 0 }}
        />
      )}
    </>
  );
};

export default NonWorkingHoursOverlay;
